import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Building, Eye, EyeOff } from 'lucide-react';
import axios from 'axios';

const Register = () => {
  const [formData, setFormData] = useState({
    cellId: '',
    fullName: '',
    professionId: '',
    organizationId: '',
    primaryMobile: '',
    alternateMobile: '',
    primaryEmail: '',
    alternateEmail: ''
  });
  const [dropdownData, setDropdownData] = useState({
    professions: [],
    organizations: [],
    cells: []
  });
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  const { register } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const response = await axios.get('/api/masters/dropdowns');
      setDropdownData({
        professions: response.data.professions,
        organizations: response.data.organizations,
        cells: response.data.cells
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await register(formData);
    if (result.success) {
      navigate('/login');
    }

    setLoading(false);
  };

  if (loadingData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-100">
            <Building className="h-6 w-6 text-primary-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Register for ECSBC Cell Tracker
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            ECSBC Professional Registration
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="cellId" className="form-label">
                ECSBC Cell *
              </label>
              <select
                id="cellId"
                name="cellId"
                required
                className="input-field"
                value={formData.cellId}
                onChange={handleChange}
              >
                <option value="">Select ECSBC Cell</option>
                {dropdownData.cells.map(cell => (
                  <option key={cell.cell_id} value={cell.cell_id}>
                    Cell-{cell.cell_no} ({cell.state_ut})
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="fullName" className="form-label">
                Full Name *
              </label>
              <input
                id="fullName"
                name="fullName"
                type="text"
                required
                className="input-field"
                placeholder="Enter your full name"
                value={formData.fullName}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="professionId" className="form-label">
                Profession *
              </label>
              <select
                id="professionId"
                name="professionId"
                required
                className="input-field"
                value={formData.professionId}
                onChange={handleChange}
              >
                <option value="">Select Profession</option>
                {dropdownData.professions.map(profession => (
                  <option key={profession.profession_id} value={profession.profession_id}>
                    {profession.profession}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="organizationId" className="form-label">
                Organization *
              </label>
              <select
                id="organizationId"
                name="organizationId"
                required
                className="input-field"
                value={formData.organizationId}
                onChange={handleChange}
              >
                <option value="">Select Organization</option>
                {dropdownData.organizations.map(org => (
                  <option key={org.organization_id} value={org.organization_id}>
                    {org.organization_name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="primaryMobile" className="form-label">
                Primary Mobile Number *
              </label>
              <input
                id="primaryMobile"
                name="primaryMobile"
                type="tel"
                required
                pattern="[0-9]{10}"
                className="input-field"
                placeholder="Enter 10-digit mobile number"
                value={formData.primaryMobile}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="alternateMobile" className="form-label">
                Alternate Mobile Number *
              </label>
              <input
                id="alternateMobile"
                name="alternateMobile"
                type="tel"
                pattern="[0-9]{10}"
                className="input-field"
                placeholder="Enter 10-digit mobile number"
                value={formData.alternateMobile}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="primaryEmail" className="form-label">
                Primary Email ID *
              </label>
              <input
                id="primaryEmail"
                name="primaryEmail"
                type="email"
                required
                className="input-field"
                placeholder="Enter your email address"
                value={formData.primaryEmail}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="alternateEmail" className="form-label">
                Alternate Email ID *
              </label>
              <input
                id="alternateEmail"
                name="alternateEmail"
                type="email"
                className="input-field"
                placeholder="Enter alternate email address"
                value={formData.alternateEmail}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="cellId" className="form-label">
                ECSBC Cell *
              </label>
              <select
                id="cellId"
                name="cellId"
                required
                className="input-field"
                value={formData.cellId}
                onChange={handleChange}
              >
                <option value="">Select ECSBC Cell</option>
                {dropdownData.cells.map(cell => (
                  <option key={cell.cell_id} value={cell.cell_id}>
                    Cell-{cell.cell_no} ({cell.state_ut})
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex justify-center py-3"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              ) : (
                'Register'
              )}
            </button>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-600">
              Already have an account?{' '}
              <Link
                to="/login"
                className="font-medium text-primary-600 hover:text-primary-500"
              >
                Sign in here
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;



